export default __webpack_public_path__ + "locales/vi/Settings.json?hash=2f09042b4f0034d27a96c379ea13787c";